export type SearchUpsellBucket = 'advanced_search' | 'paper_finder';
export type SearchUpsellSurface = 'search_inline' | 'search_modal';

export const SEARCH_UPSELL_TEST_NAME =
  'demo_day_2026_paper_finder_vs_advanced_search';
export const SEARCH_UPSELL_IMPRESSION_SOURCE = 'search_upsell_experiment';

const SEARCH_UPSELL_ENTITY_IDS: Record<
  SearchUpsellBucket,
  Record<SearchUpsellSurface, number>
> = {
  advanced_search: {
    search_inline: 1,
    search_modal: 2,
  },
  paper_finder: {
    search_inline: 3,
    search_modal: 4,
  },
};

type SearchUpsellTracking = {
  entity_id: number;
  extra: Record<string, string>;
  source: string;
};

export const getSearchUpsellTracking = (
  bucket: SearchUpsellBucket,
  sourceSurface: SearchUpsellSurface,
  trigger: string,
): SearchUpsellTracking => ({
  entity_id: SEARCH_UPSELL_ENTITY_IDS[bucket][sourceSurface],
  extra: {
    test_name: SEARCH_UPSELL_TEST_NAME,
    bucket,
    upsell_type: bucket,
    source_surface: sourceSurface,
    trigger,
  },
  source: SEARCH_UPSELL_IMPRESSION_SOURCE,
});

type VisibilityOptions = {
  advancedSearchEligible: boolean;
  advancedSearchModalOpen: boolean;
  paperFinderEligible: boolean;
  paperFinderEligibilityPending: boolean;
  paperFinderUrl?: string;
  bucket?: SearchUpsellBucket;
};

type SearchUpsellVisibility = {
  advancedSearchInline: boolean;
  advancedSearchModal: boolean;
  paperFinder: boolean;
};

export function getSearchUpsellVisibility({
  advancedSearchEligible,
  advancedSearchModalOpen,
  paperFinderEligible,
  paperFinderEligibilityPending,
  paperFinderUrl,
  bucket,
}: VisibilityOptions): SearchUpsellVisibility {
  const showAssignedAdvancedSearch =
    !paperFinderEligible || bucket === 'advanced_search';

  return {
    advancedSearchInline: advancedSearchEligible && showAssignedAdvancedSearch,
    advancedSearchModal:
      advancedSearchModalOpen &&
      !paperFinderEligibilityPending &&
      showAssignedAdvancedSearch,
    paperFinder:
      paperFinderEligible &&
      bucket === 'paper_finder' &&
      Boolean(paperFinderUrl),
  };
}

export function shouldTrackAdvancedSearchInline(
  bucket: SearchUpsellBucket | undefined,
  advancedSearchModalIsCanonical: boolean,
): boolean {
  return bucket === 'advanced_search' && !advancedSearchModalIsCanonical;
}
